import React, { forwardRef } from 'react'
import { Button } from 'semantic-ui-react'
import CustomPopup from '../customPopup'
import EmergencyProcedureShipmentList from './EmergencyProcedureShipmentList'
import { useState } from 'react'
import { ModalLoader } from '@commonComponents/ModalLoader'
import { HttpClient } from '../../../commonApis/httpClient'

function waitforme(millisec) {
    return new Promise(resolve => { setTimeout(() => { resolve('') }, millisec); })
}

const EmergencyProcedure = forwardRef(({ translate, brokerGuid, customStateMapper }, ref) => {
    const [shipmentData, setShipmentData] = useState({
        shipmentList: [], selectAll: false
    })
    const [isError, setError] = useState(null)
    const [isLoading, setLoader] = useState('initial') // initial, loading, success
    const getAllShipment = async () => {
        try {
            setLoader('loading')
            const response = await HttpClient.custom({
                data: {
                    eventId: "",
                    eventMessage: {},
                    eventType: "GET_ALL_DMS_SHIPMENTS"
                }
            })
            let responseData = response?.data?.eventMessage?.row?.map(item => ({ ...item, isChecked: false })) || []
            if (!responseData?.length)
                responseData = getData()?.map(item => ({ ...item, isChecked: false }))
            setShipmentData((prevShipmentData) => ({
                ...prevShipmentData,
                shipmentList: responseData
            }))
        } catch (err) {
            console.error(err)
        } finally {
            setLoader('success')
        }
    }
    const onMarkShipment = ({ checked }, shipmentId) => {
        setShipmentData((prevShipmentData) => {
            const shipmentListUpdated = prevShipmentData?.shipmentList?.map(
                (item) => item?.shipmentId == shipmentId ? ({ ...item, isChecked: checked }) : item
            )
            return {
                ...prevShipmentData,
                selectAll: shipmentListUpdated?.every(item => item?.isChecked),
                shipmentList: shipmentListUpdated
            }
        })
    }
    const filterShipment = (shipmentList) => shipmentList?.filter((item) => item?.isChecked)?.map(({ isChecked, ...rest }) => rest)

    const createEmergencyPayload = (userEvent, selectedShipments) => {
        return {
            eventId: "",
            eventMessage: {
                clickedByUser: userEvent,
                selectedShipments: selectedShipments
            },
            eventType: "PERFORM_OPERATION",
            eventTime: Date.now(),
            responseTopic: ""
        }
    }

    const onDelete = () => {
        setShipmentData((prevShipmentData) => {
            const shipmentListUpdated = prevShipmentData?.shipmentList?.filter(
                (item) => !item?.isChecked
            )
            return {
                ...prevShipmentData,
                selectAll: false,
                shipmentList: shipmentListUpdated
            }
        })
    }

    const onRelease = async (shipmentList) => {
        try {
            const selectedShipments = filterShipment(shipmentList)
            const isValid = selectedShipments?.every(
                shipment => ['STATE_NOOD_FILED_DECL_NOT_SENT', 'STATE_NOOD_FILED_DECL_SENT']?.includes(shipment?.customsState)
            )
            if (!selectedShipments?.length) {
                setError('Please select atleast 1 shipment')
            } else if (!isValid) {
                setError('Please select all shipments with status NOOD_FILED_DECL_NOT_SENT to mark NOOD RELEASED')
            } else {
                setError(null)
                setLoader('loading')
                const payload = createEmergencyPayload("BUTTON_SAVE", selectedShipments)
                const response = await HttpClient.custom({
                    data: payload
                })
                // setTimeout(()=>getAllShipment(),2000)
                await waitforme(2000)
                await getAllShipment()
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoader('success')
        }
    }

    const onFile = async (shipmentList) => {
        try {
            const selectedShipments = filterShipment(shipmentList)
            const isValid = selectedShipments?.every(
                shipment => shipment?.customsState === 'STATE_NOOD_RELEASED_DECL_NOT_SENT'
            )
            if (!selectedShipments?.length) {
                setError('Please select atleast 1 shipment')
            } else if (!isValid) {
                setError('Please select all shipments with status NOOD_RELEASED_DECL_NOT_SENT to mass file the shipments')
            } else {
                setError(null)
                setLoader('loading')
                const payload = createEmergencyPayload("BUTTON_FILE", selectedShipments)
                const response = await HttpClient.custom({
                    data: payload
                })
                // setTimeout(()=>getAllShipment(),2000)
                await waitforme(2000)
                await getAllShipment()
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoader('success')
        }
    }

    const updateCustomState = async (params) => {
        if(!params?.customsState) return null
        setLoader('loading')
        const payload = {
            "eventId": "",
            "eventMessage": {
                "selectedShipments": [params],
            },
            "eventType": "MOVE_TO_ORIGINAL_STATE",
            "eventTime": Date.now(),
            "responseTopic": ""
        }
        try {
            const response = await HttpClient.custom({
                data: payload
            })
        } catch (err) {
            console.error(err)
            setLoader('success')
        }
        // setTimeout(()=>getAllShipment(),2000)
        await waitforme(2000)
        await getAllShipment()
        setLoader('success')
    }

    return (
        <>
            {isLoading === 'loading' && <ModalLoader
                loading={isLoading === 'loading'}
                message='Loading...'
            />}
            <CustomPopup
                closeIcon
                ref={ref}
                onClose={() => ref.current?.closePopup()}
                content={true}
                header={<div>{`${translate("EMERGENCY_PROCEDURE")}`}</div>}
                description={<div>
                    <EmergencyProcedureShipmentList
                        translate={translate}
                        shipmentData={shipmentData}
                        setShipmentData={setShipmentData}
                        isLoading={isLoading}
                        setLoader={setLoader}
                        onMarkShipment={onMarkShipment}
                        getAllShipment={getAllShipment}
                        updateCustomState={updateCustomState}
                        setError={setError}
                        customStateMapper={customStateMapper}
                    />
                </div>}
                className="emergencyDocumentPopup"
                actions={
                    <div className="actions">
                        <span style={{ color: 'red' }}>
                            {isError ? isError : null}
                        </span>
                        <Button secondary onClick={() => ref.current?.closePopup()}>
                            {translate("CANCEL")}
                        </Button>
                        <Button negative onClick={onDelete}>
                            {translate("DELETE")}
                        </Button>
                        <Button positive onClick={() => onRelease(shipmentData?.shipmentList)}>
                            {translate("RELEASE")}
                        </Button>
                        <Button color='teal' onClick={() => onFile(shipmentData?.shipmentList)}>
                            {translate("FILE_DMS")}
                        </Button>
                    </div>
                }
            />
        </>
    )
})

export default EmergencyProcedure